<template>
  <div
    class="p-4 mt-4 rounded-xl bg-white [box-shadow:0_0_5px_0_rgba(0,0,0,.18)] hover:[box-shadow:0_0_5px_0_rgba(0,0,0,.3)] dark:bg-transparent transition-all duration-150 dark:hover:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.7)] dark:[box-shadow:0_0_.15em_.1em_rgba(98,69,116,0.5)]">
    <div class="flex items-center gap-4">
      <span>
        <NuxtImg loading="lazy" :src="img" :alt="title" :width="width" :height="height"
          class="[filter:drop-shadow(2px_2px_1px_rgba(0,0,0,0.1))] shrink-0" format="webp" v-if="img" />
      </span><span>{{ title }}</span>
    </div>
    <div class="flex gap-2 flex-wrap mt-4">
      <template v-for="stack in stacs" :key="stack.title">
    <NuxtLink
      v-if="stack.link"
      :to="stack.link"
      class="flex justify-center "
    >
      <WrTag :tag="stack.title" :isLink="stack.link.length > 0" />
    </NuxtLink>
    <div
      v-else
      class="flex justify-center"
    >
      <WrTag :tag="stack.title" />
    </div>
  </template>
    </div>
  </div>
</template>

<script setup>
defineProps({
  img: String,
  title: String,
  stacs: Array,
  url: String,
  width: { type: Number, default: 32 },
  height: { type: Number, default: 32 },
  layoutChange: { type: Boolean, default: false },
});
</script>

<style lang="scss" scoped></style>
